import React from 'react'
import { Icon } from 'semantic-ui-react'

import { Mode } from '../../redux/types/ui'
import { navigateToProductEdit } from '../../utils/navigate'

interface Props {
  gettingProductId: number | undefined
  lastAction: Mode
  dispatch: any
  row: any
}

export const TableCellEdit = (props: Props) => {
  const { gettingProductId, lastAction, row } = props
  return (
    <Icon
      link
      disabled={gettingProductId != null}
      loading={lastAction === 'edit' && gettingProductId === row.values.id}
      name={lastAction === 'edit' && gettingProductId === row.values.id ? 'spinner' : 'pencil'}
      color="grey"
      onClick={() => {
        navigateToProductEdit({ productId: row.values.id })
      }}
    />
  )
}
